import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { Bar } from 'react-chartjs-2';
import { Chart, BarElement, Legend, LinearScale, Tooltip, CategoryScale } from 'chart.js';
import { injectIntl } from 'react-intl';
import { listItemMsg } from '@/shared/components/FormattedListValue';
import { dynamicSort } from '@/shared/utils/dynamicSort';
import { percentageTooltipLabel } from '@/shared/utils/chartjsHelpers';
import intlShape from '@/shared/utils/intlShape';

Chart.register(BarElement, Legend, LinearScale, Tooltip, CategoryScale);

const CompliancePerTypeChart = ({ intl, data: rawData }) => {
  const [chartData, setChartData] = useState(null);

  useEffect(() => {
    const { complianceForTypes } = rawData;

    const orderedCompliancies = complianceForTypes
      .map(x => ({
        ...x,
        label: intl.formatMessage(listItemMsg('compliancetype', x.compliancyType)),
      }))
      .sort(dynamicSort('label'));

    setChartData({
      labels: orderedCompliancies.map(x =>
        intl.formatMessage(listItemMsg('compliancetype', x.compliancyType)),
      ),
      datasets: [
        {
          label: intl.formatMessage(listItemMsg('compliancestatus', 2)),
          data: orderedCompliancies.map(x => x.ok),
          backgroundColor: '#00B295',
          hoverBackgroundColor: '#00a086',
          borderColor: '#ffffff',
          hoverBorderColor: '#ffffff',
        },
        {
          label: intl.formatMessage(listItemMsg('compliancestatus', 1)),
          data: orderedCompliancies.map(x => x.partiallyOk),
          backgroundColor: '#F0A800',
          hoverBackgroundColor: '#d89700',
          borderColor: '#ffffff',
          hoverBorderColor: '#ffffff',
        },
        {
          label: intl.formatMessage(listItemMsg('compliancestatus', 0)),
          data: orderedCompliancies.map(x => x.notOk),
          backgroundColor: '#B80016',
          hoverBackgroundColor: '#a60014',
          borderColor: '#ffffff',
          hoverBorderColor: '#ffffff',
        },
      ],
    });
  }, [rawData, intl]);
  const chartOptions = {
    responsive: true,
    maintainAspectRatio: false,
    indexAxis: 'y',
    interaction: { mode: 'index' },

    scales: {
      x: {
        stacked: true,
        min: 0,
        max: 100,
        ticks: {
          callback: value => `${value}%`,
        },
      },
      y: {
        stacked: true,
        gridLines: { display: false },
      },
    },
    plugins: {
      tooltip: {
        enabled: true,
        displayColors: false,
        callbacks: {
          label: percentageTooltipLabel,
        },
      },
    },
  };
  return !chartData ? null : <Bar data={chartData} options={chartOptions} />;
};
CompliancePerTypeChart.propTypes = {
  intl: intlShape.isRequired,
  data: PropTypes.shape({}).isRequired,
};

export default injectIntl(CompliancePerTypeChart);
